var map = {
	"./Kanagawa/map/agriculture/Kanagawa_AgricultureOrange_CMIP5RCP26_MIROC_No_R2081_2100.png": 1778,
	"./Kanagawa/map/agriculture/Kanagawa_AgricultureOrange_CMIP5RCP26_MRI_No_R2081_2100.png": 1779,
	"./Kanagawa/map/agriculture/Kanagawa_AgricultureOrange_CMIP5RCP85_MIROC_No_R2081_2100.png": 1780,
	"./Kanagawa/map/agriculture/Kanagawa_AgricultureOrange_CMIP5RCP85_MRI_No_R2081_2100.png": 1781,
	"./Kanagawa/map/agriculture/Kanagawa_AgricultureTankan_CMIP5RCP26_MIROC_No_R2081_2100.png": 1782,
	"./Kanagawa/map/agriculture/Kanagawa_AgricultureTankan_CMIP5RCP26_MRI_No_R2081_2100.png": 1783,
	"./Kanagawa/map/agriculture/Kanagawa_AgricultureTankan_CMIP5RCP85_MIROC_No_R2081_2100.png": 1784,
	"./Kanagawa/map/agriculture/Kanagawa_AgricultureTankan_CMIP5RCP85_MRI_No_R2081_2100.png": 1785,
	"./Nagano/map/agriculture/Nagano_AgricultureOrange_CMIP5RCP26_MIROC_No_R2081_2100.png": 1786,
	"./Nagano/map/agriculture/Nagano_AgricultureOrange_CMIP5RCP26_MRI_No_R2081_2100.png": 1787,
	"./Nagano/map/agriculture/Nagano_AgricultureOrange_CMIP5RCP85_MIROC_No_R2081_2100.png": 1788,
	"./Nagano/map/agriculture/Nagano_AgricultureOrange_CMIP5RCP85_MRI_No_R2081_2100.png": 1789,
	"./Nagano/map/agriculture/Nagano_AgricultureTankan_CMIP5RCP26_MIROC_No_R2081_2100.png": 1790,
	"./Nagano/map/agriculture/Nagano_AgricultureTankan_CMIP5RCP26_MRI_No_R2081_2100.png": 1791,
	"./Nagano/map/agriculture/Nagano_AgricultureTankan_CMIP5RCP85_MIROC_No_R2081_2100.png": 1792,
	"./Nagano/map/agriculture/Nagano_AgricultureTankan_CMIP5RCP85_MRI_No_R2081_2100.png": 1793,
	"./Tokyo/map/agriculture/Tokyo_AgricultureOrange_CMIP5RCP26_GFDL_No_R2081_2100.png": 1794,
	"./Tokyo/map/agriculture/Tokyo_AgricultureOrange_CMIP5RCP26_HadGEM_No_R2081_2100.png": 1795,
	"./Tokyo/map/agriculture/Tokyo_AgricultureOrange_CMIP5RCP26_MIROC_No_R2081_2100.png": 1796,
	"./Tokyo/map/agriculture/Tokyo_AgricultureOrange_CMIP5RCP26_MRI_No_R2081_2100.png": 1797,
	"./Tokyo/map/agriculture/Tokyo_AgricultureOrange_CMIP5RCP85_MIROC_No_R2081_2100.png": 1798,
	"./Tokyo/map/agriculture/Tokyo_AgricultureOrange_CMIP5RCP85_MRI_No_R2081_2100.png": 1799,
	"./Tokyo/map/agriculture/Tokyo_AgricultureTankan_CMIP5RCP26_MIROC_No_R2081_2100.png": 1800,
	"./Tokyo/map/agriculture/Tokyo_AgricultureTankan_CMIP5RCP26_MRI_No_R2081_2100.png": 1801,
	"./Tokyo/map/agriculture/Tokyo_AgricultureTankan_CMIP5RCP85_MIROC_No_R2081_2100.png": 1802,
	"./Tokyo/map/agriculture/Tokyo_AgricultureTankan_CMIP5RCP85_MRI_No_R2081_2100.png": 1803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1777;